import React, { Fragment, useState } from "react";
import { useWindowDimensions } from "../../../../hooks/useDimensionHook";
import { TimesheetTable } from "../TimesheetTable/TimesheetTable";
import { TimesheetList } from "../TimesheetList/TimesheetList";
import { UpdateTimeModal } from "../UpdateTimeModal/UpdateTimeModal";
import { useDispatch, useSelector } from "react-redux";
import { editTimesheet } from "../../../../redux/actions";

const TimesheetData = ({
  handleApproveRejectClick,
  handlePageChange,
  page,
}) => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const { editTimeSheetLoading } = useSelector(
    (state) => state.TimesheetDetailsReducer
  );
  const [isShowTimeModal, setIsShowTimeModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  const handleOpenTimeModal = (data) => {
    setSelectedData(data);
    setIsShowTimeModal(true);
  };

  const updateTime = (values) => {
    try {
      dispatch(editTimesheet({ ...values, callBack: successCallBack }));
    } catch (error) {}
  };

  const successCallBack = () => {
    setIsShowTimeModal(false);
    handlePageChange();
  };

  return (
    <Fragment>
      {width > 768 ? (
        <TimesheetTable
          page={page}
          handleApproveRejectClick={handleApproveRejectClick}
          handleOpenTimeModal={handleOpenTimeModal}
          handlePageChange={handlePageChange}
        />
      ) : (
        <TimesheetList
          page={page}
          handlePageChange={handlePageChange}
          handleApproveRejectClick={handleApproveRejectClick}
          handleOpenTimeModal={handleOpenTimeModal}
        />
      )}
      {isShowTimeModal && (
        <UpdateTimeModal
          open={isShowTimeModal}
          data={selectedData}
          handleClose={() => setIsShowTimeModal(false)}
          updateTime={updateTime}
          loading={editTimeSheetLoading}
        />
      )}
    </Fragment>
  );
};

export { TimesheetData };
